exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = Y1aA
// module chunks = 1